<label *ngIf="title">{{ title | translate }}</label>
<div class="btn-toolbar" role="toolbar">
  <ng-container
    *ngFor="
      let button of buttons || [];
      let index = index;
      trackBy: getButtonValue
    "
  >
    <xux-expand-collapse-icon
      *ngIf="button.expandable; else commonBtnBlock"
      [iconConfig]="button.expandIconConfigObs | async"
      [collapsed]="(button.expandIconConfigObs | async)?.collapse"
      [attr.data-e2e-id]="'modal-btn-' + button.value"
      [style.order]="button.flexOrder || 0"
      [ngClass]="
        index === 0 || index === buttons.length - 1
          ? button.class
          : defaultBtnMarginClass + button.class
      "
      (onCollapsed)="handleBtnClick(button, null, $event)"
    ></xux-expand-collapse-icon>
    <ng-template #commonBtnBlock>
      <button
        *ngIf="
          !button.childItems && !(button.hidden || (button.hiddenObs | async));
          else dropDownBlock
        "
        [attr.data-e2e-id]="'modal-btn-' + button.value"
        [style.order]="button.flexOrder || 0"
        [disabled]="isDisabled(button) | async"
        [ngClass]="
          index === 0 || index === buttons.length - 1
            ? button.class
            : defaultBtnMarginClass + button.class
        "
        class="btn xux-btn btn-xux btn-default"
        type="button"
        [title]="
          ((isDisabled(button) | async)
            ? (button.disableTooltipObs | async) || button.disableTooltip || ''
            : button.tooltip || ''
          ) | translate
        "
        (appThrottleClick)="handleBtnClick(button)"
      >
        <span
          *ngIf="button.glyphicon"
          class="glyphicon"
          [ngClass]="button.glyphicon"
          aria-hidden="true"
        ></span>
        <xvi-entity-caption
          *ngIf="button.captionObs; else btnCaption"
          [data]="button.captionObs | async | translate"
        ></xvi-entity-caption>
        <ng-template #btnCaption
          ><xvi-entity-caption
            [data]="button.caption | translate"
          ></xvi-entity-caption
        ></ng-template>
      </button>

      <ng-template #dropDownBlock>
        <div
          *ngIf="!(button.hidden || (button.hiddenObs | async))"
          class="xux-dropdown"
          [ngClass]="
            index === 0 || index === buttons.length - 1
              ? ''
              : defaultBtnMarginClass
          "
          dropdown
          [style.order]="button.flexOrder || 0"
        >
          <div *ngIf="button.splitDropdown" class="split-dropdown">
            <button
              [disabled]="isDisabled(button) | async"
              [title]="button.tooltip ? (button.tooltip | translate) : ''"
              [attr.data-e2e-id]="'modal-btn-' + button.value"
              [ngClass]="button.class"
              class="btn xux-btn btn-xux"
              type="button"
              (appThrottleClick)="handleBtnClick(button)"
            >
              <xvi-entity-caption
                [data]="button.caption | translate"
              ></xvi-entity-caption>
              <xux-icon
                *ngIf="button.glyphicon"
                icon="button.glyphicon"
              ></xux-icon>
            </button>
            <button
              dropdownToggle
              [attr.data-e2e-id]="'modal-btn-toggle-dropdown'"
              [ngClass]="button.class"
              class="btn xux-btn btn-xux dropdown-toggle"
              [class.disabled]="
                (isDisabled(button) | async) || !button?.childItems?.length
              "
              type="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <xux-icon icon="icon-arrow-down"></xux-icon>
            </button>
          </div>

          <div *ngIf="!button.splitDropdown">
            <button
              dropdownToggle
              [disabled]="isDisabled(button) | async"
              [title]="(button.tooltip ? button.tooltip : '') | translate"
              [attr.data-e2e-id]="'modal-btn-toggle-dropdown'"
              [ngClass]="button.class"
              type="button"
              class="btn xux-btn btn-xux dropdown-toggle"
              [class.disabled]="
                (isDisabled(button) | async) || !button?.childItems?.length
              "
              aria-haspopup="true"
              aria-expanded="false"
            >
              <xvi-entity-caption
                [data]="button.caption | translate"
              ></xvi-entity-caption>
              <xux-icon icon="icon-arrow-down"></xux-icon>
            </button>
          </div>

          <ul
            class="dropdown-menu"
            *dropdownMenu
            [ngClass]="[
              'dropdown-menu-position-' + button.dropdownMenuPosition || 'left',
            ]"
          >
            <li
              *ngFor="
                let childItem of button.childItems;
                trackBy: trackByChildItemsValue
              "
              [attr.data-e2e-id]="'xux-btn-' + childItem.value"
              [class.divider]="childItem.value === 'separator'"
              [class.after-last-item]="childItem.class === 'after-last-item'"
            >
              <a
                *ngIf="
                  !childItem.childItems &&
                  !(childItem.hidden || (childItem.hiddenObs | async))
                "
                [title]="
                  (childItem.tooltip ? childItem.tooltip : '') | translate
                "
                [class.disabled]="childItem.disabled"
                [ngClass]="childItem.class"
                class="xux-action-button btn full-width"
                (appThrottleClick)="handleBtnClick(childItem, button)"
              >
                <xvi-entity-caption
                  [data]="childItem.caption | translate"
                ></xvi-entity-caption>
              </a>

              <ng-template
                [ngIf]="
                  childItem.childItems &&
                  !(childItem.hidden || (childItem.hiddenObs | async))
                "
              >
                <span
                  [ngClass]="childItem.class"
                  class="xux-action-button btn full-width row-button-cell"
                  *ngFor="
                    let cell of childItem.childItems;
                    trackBy: trackByCaptionOrValue
                  "
                >
                  <span [title]="cell.caption | translate"
                    ><xvi-entity-caption
                      [data]="cell.caption | translate"
                    ></xvi-entity-caption
                  ></span>

                  <xux-icon
                    *ngIf="cell.glyphicon"
                    [icon]="cell.glyphicon"
                    class="action-icon"
                    (appThrottleClick)="handleBtnClick(cell, childItem)"
                  ></xux-icon>
                </span>
              </ng-template>
            </li>
            <div class="empty-block" *ngIf="!button.childItems.length"></div>
          </ul>
        </div>
      </ng-template>
    </ng-template>
  </ng-container>
</div>
